module.exports = __webpack_public_path__ + "templates/calendar-my_bookings.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/booking/templates/calendar-my_bookings.html
// module id = 3yVN
// module chunks = 1